import { Link } from 'react-router-dom';
import { matrixArticles } from '@/mocks/home';

export default function MatrixGrid() {
  return (
    <section className="py-16 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row lg:items-end justify-between gap-4 mb-12">
          <div>
            <h4 className="text-sm font-semibold text-foreground-400 uppercase tracking-wider">Breaking News</h4>
            <h2 className="text-3xl md:text-4xl font-heading font-bold text-foreground-950 mt-1">
              最新<span className="italic text-primary-600">爆料</span>
            </h2>
          </div>
          <p className="text-sm text-foreground-500 max-w-md lg:text-right leading-relaxed">
            每日实时更新最新网红黑料与娱乐圈爆料，黑料在线吃瓜第一线，不错过任何热门事件
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {matrixArticles.map((article, index) => (
            <Link
              key={article.id}
              to={`/article/${article.id}`}
              className="group flex flex-col bg-background-100 rounded-xl overflow-hidden hover:bg-background-200/70 transition-colors cursor-pointer"
            >
              <div className="relative h-52 overflow-hidden">
                <img
                  src={article.imageUrl}
                  alt={article.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="p-5 flex flex-col flex-1">
                <span className="inline-block self-start px-2.5 py-1 rounded-full bg-accent-100 text-accent-700 text-xs font-semibold mb-3 whitespace-nowrap">
                  {article.category}
                </span>
                <h3 className="text-base md:text-lg font-semibold text-foreground-950 leading-snug line-clamp-2 group-hover:text-primary-600 transition-colors mb-auto">
                  {article.title}
                </h3>
                <div className="flex items-center gap-5 mt-4 text-xs text-foreground-400">
                  <span>{article.date}</span>
                  <span className="flex items-center gap-1">
                    <i className="ri-eye-line w-3.5 h-3.5 flex items-center justify-center"></i>
                    {article.views}
                  </span>
                  <span className="flex items-center gap-1">
                    <i className="ri-chat-3-line w-3.5 h-3.5 flex items-center justify-center"></i>
                    {article.comments}
                  </span>
                </div>
              </div>
            </Link>
          ))}
        </div>

        <div className="mt-10 text-center">
          <Link
            to="/category/wanghong-baoliao"
            className="inline-flex items-center gap-2 text-sm font-semibold text-primary-600 hover:text-primary-700 transition-colors cursor-pointer whitespace-nowrap"
          >
            查看更多爆料
            <i className="ri-arrow-right-line w-4 h-4 flex items-center justify-center"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}